import { Lang, loadLangFromCms } from './i18n'
import { languages } from './languages'
import { register } from 'svelte-i18n'

export async function registerLanguages(tenantId: string) {
	const langs = await languages.load()

	// loads other languages asynchronously
	for (const lang of langs.filter((lang) => lang.code !== Lang.en)) {
		register(lang.code, () => loadLangFromCms(lang.code, tenantId))
	}
}
